import { PropsWithChildren, createContext, useContext, useState } from 'react';

export type SimulationMode = 'DEFAULT' | 'FREEZING' | 'PUBLICATION';

type GanttSimulationContextType = {
  isSimulation: boolean;
  mode: SimulationMode;
  setMode: (mode: SimulationMode) => void;
};

const GanttSimulationContext = createContext<GanttSimulationContextType>({
  isSimulation: false,
  mode: 'DEFAULT',
  setMode: () => null,
});

export const useIsGanttSimulation = () => {
  const { isSimulation } = useContext(GanttSimulationContext);

  return isSimulation;
};

export const useGanttSimulationContext = () => useContext(GanttSimulationContext);

export const GanttSimulationProvider = ({ children }: PropsWithChildren) => {
  const [mode, setMode] = useState<SimulationMode>('DEFAULT');

  return (
    <GanttSimulationContext.Provider value={{ isSimulation: true, mode, setMode }}>
      {children}
    </GanttSimulationContext.Provider>
  );
};
